<template>
  <v-container fluid class="docs mt-4">
    <v-row>
      <v-col cols="12">
        <LogicaIntervencaoCard :logicaIntervencao="produto" isParent="true"></LogicaIntervencaoCard>
      </v-col>

      <v-col cols="12">
        <IndicadorGerenciamento :logicaIntervencao="produto"></IndicadorGerenciamento>
      </v-col>

      <v-col class="mt-n4" cols="12">
        <v-card class="mx-1">
          <v-card-title >
            <p>Atividades</p><span class="grey--text font-weight-regular subtitle-2 pt-1">{{'\xa0 (' +  atividades.length }} total) </span>
          </v-card-title>
          <v-divider></v-divider>
        </v-card>

        <template v-for="(atividade, index) in atividades">
          <LogicaIntervencaoListItem
            :key="'atividade-' + index"
            :logicaIntervencao="atividade"
          ></LogicaIntervencaoListItem>
        </template>

        <v-card tile class="mx-1">
          <v-card-text
            class="mb-12"
            style="height: 50px; position: relative"
          >
            <v-fab-transition>
              <LogicaIntervencaoCriacao
                titulo="Criar Atividade"
                nivel="ATIVIDADE"
                :realizacao="produto.logicaIntervencao"
                :produto="produto"
              ></LogicaIntervencaoCriacao>
            </v-fab-transition>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import LogicaIntervencaoCard from "@/pages/Projeto/components/LogicaIntervencao/LogicaIntervencaoCard";
import LogicaIntervencaoListItem from "@/pages/Projeto/components/LogicaIntervencao/LogicaIntervencaoListItem";
import LogicaIntervencaoCriacao from "@/pages/Projeto/components/LogicaIntervencao/LogicaIntervencaoAdd";
import IndicadorGerenciamento from "@/pages/Projeto/pages/Indicador/Gerenciamento/IndicadorGerenciamento";

export default {
  components: { LogicaIntervencaoCard, LogicaIntervencaoListItem, LogicaIntervencaoCriacao, IndicadorGerenciamento },
  computed: {
    produto() {
      return this.$store.getters["logicaIntervencao/byId"](parseInt(this.$route.params.logicaIntervencaoId));
    },
    atividades() {
      return this.$store.getters["logicaIntervencao/atividadesByProduto"](parseInt(this.produto.id));      
    }    
  },

  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style src="./Produto.scss" lang="scss"/>
